import User from 'interfaces/User';
import views from 'patient/views';
import sharedPaths from 'shared/routing/paths';
import checkIsPatient from 'shared/utils/isPatient';
import sharedUserViews from 'shared/views';
import paths from './paths';

const accessGranted = (user: User): boolean => checkIsPatient(user);

export const USER_HOME = {
  isPrivate: true,
  accessGranted: accessGranted,
  component: views.UserHome,
  path: sharedPaths.USER_HOME,
  title: 'Inicio'
};

export const USER_PROFILE = {
  isPrivate: true,
  accessGranted: accessGranted,
  component: sharedUserViews.UserProfile,
  path: sharedPaths.USER_PROFILE,
  title: 'Tu perfil'
};

export const USER_BACKUP = {
  isPrivate: true,
  accessGranted,
  component: sharedUserViews.UserBackup,
  path: sharedPaths.USER_BACKUP,
  title: 'Privacidad'
};

export const TEST_REQUEST = {
  isPrivate: true,
  component: views.TestRequest,
  path: paths.TEST_REQUEST,
  accessGranted
};

export const PATIENT_EVOLUTION = {
  isPrivate: true,
  component: views.PatientEvolution,
  path: paths.PATIENT_EVOLUTION,
  accessGranted
};

export const PATIENT_PATHOLOGY_TASK_LIST = {
  isPrivate: true,
  component: views.PatientPathologyTaskList,
  path: paths.PATIENT_PATHOLOGY_TASK_LIST,
  accessGranted
};

export const NOTIFICATION_LIST = {
  isPrivate: true,
  component: sharedUserViews.NotificationList,
  path: sharedPaths.NOTIFICATION_LIST,
  title: 'Notificaciones',
  accessGranted
};

export const LOGOUT = {
  isPrivate: true,
  accessGranted,
  component: sharedUserViews.Logout,
  path: sharedPaths.LOGOUT,
  title: null
};

export const CONTACT_FORM = {
  isPrivate: true,
  accessGranted,
  component: sharedUserViews.ContactForm,
  path: sharedPaths.CONTACT_FORM,
  title: 'Contacto'
};

export const EVENTS_LIST = {
  isPrivate: true,
  component: views.EventsList,
  path: sharedPaths.EVENTS_LIST,
  title: 'Eventos',
  accessGranted
};


export const EVENT = {
  isPrivate: true,
  component: sharedUserViews.Event,
  path: sharedPaths.EVENT,
  title: 'Eventos',
  accessGranted
};

export const PRODUCT_RECOMMENDATION_ROUTINE = {
  isPrivate: true,
  component: views.ProductRecommendationRoutine,
  path: paths.PRODUCT_RECOMMENDATION_ROUTINE,
  accessGranted
};

export const TIP_LIBRARY = {
  isPrivate: true,
  component: views.TipLibrary,
  path: paths.TIP_LIBRARY,
  accessGranted
};

const routes = [
  CONTACT_FORM,
  LOGOUT,
  USER_HOME,
  USER_BACKUP,
  USER_PROFILE,
  TEST_REQUEST,
  PATIENT_EVOLUTION,
  PATIENT_PATHOLOGY_TASK_LIST,
  NOTIFICATION_LIST,
  EVENTS_LIST,
  EVENT,
  PRODUCT_RECOMMENDATION_ROUTINE,
  TIP_LIBRARY
];

export default routes;
